export const triggerHotJarEvent = (eventName) => {
  if (window.hj) {
    window.hj('event', eventName);
  } else {
    // eslint-disable-next-line no-console
    console.warn('Hotjar is not loaded yet');
  }
};
